import { Icon } from '@iconify/react';

const VIEWS = [
    { value: 'card', label: 'Cards', icon: 'mdi:view-grid-outline' },
    { value: 'list', label: 'List', icon: 'mdi:format-list-bulleted' },
];

const VisitorListHeader = ({ viewMode, onViewModeChange, canCreate, onCreate }) => (
    <div className="tw-p-4 tw-border-b tw-border-gray-100 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3">
        <div>
            <h1 className="tw-mb-0 tw-text-base tw-font-bold tw-text-gray-800">Visitors</h1>
            <p className="tw-mb-0 tw-text-[11px] tw-text-gray-500 tw-mt-0.5">
                The people registered at your gate — one record per phone number
            </p>
        </div>

        <div className="tw-flex tw-items-center tw-gap-2">
            <div className="tw-inline-flex tw-p-0.5 tw-bg-gray-100 tw-rounded-md">
                {VIEWS.map(v => (
                    <button
                        key={v.value}
                        type="button"
                        onClick={() => onViewModeChange(v.value)}
                        title={`${v.label} view`}
                        className={`tw-flex tw-items-center tw-gap-1 tw-px-2.5 tw-py-1.5 tw-rounded tw-text-xs tw-font-medium tw-transition-colors ${viewMode === v.value ? 'tw-bg-white tw-text-gray-800 tw-shadow-sm' : 'tw-text-gray-500 hover:tw-text-gray-700'}`}
                    >
                        <Icon icon={v.icon} className="tw-text-base" />
                        {v.label}
                    </button>
                ))}
            </div>

            {canCreate && (
                <button
                    onClick={onCreate}
                    className="tw-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-2 tw-rounded-md tw-text-xs tw-font-medium tw-text-white tw-bg-sky-600 hover:tw-bg-sky-700 tw-transition-colors"
                >
                    <Icon icon="mdi:account-plus-outline" className="tw-text-base" />
                    Register Visitor
                </button>
            )}
        </div>
    </div>
);

export default VisitorListHeader;
